<template>
  <div>
    <!--    <div class="panel-title position-relative w-100 title">-->
    <!--      <p>{{ $t('pages.projects.title') }}</p>-->
    <!--    </div>-->
    <div class="component-roomtypes">
      <b-modal
        id="projectModal"
        ref="projectModal"
        no-fade
        centered
        static
        size="lg"
        modal-class="form-modal"
        :ok-title="$t(`buttons.${project.id != null ? 'update' : 'save'}`)"
        ok-variant="primary"
        :cancel-title="$t('buttons.cancel')"
        cancel-variant="outline-primary"
        :ok-disabled="updatePending || !$refs.projectForm || !formValid || !$refs.projectForm.flags.valid"
        :cancel-disabled="updatePending"
        :no-close-on-esc="updatePending"
        :no-close-on-backdrop="updatePending"
        :hide-header-close="updatePending"
        @show="modalScroll"
        @hidden="modalScroll"
        @ok.prevent="processForm"
      >
        <template #modal-header-close>
          <icon width="20" height="20" class="d-none d-md-block" type="times"/>
          <icon width="10" height="18" class="d-md-none" type="arrow-left"/>
        </template>
        <template #modal-title>
          {{ modalTitle }}
        </template>
        <ValidationObserver ref="projectForm" slim>
          <div class="position-relative-w-100">
            <p class="txt-red">
              {{ $t('pages.projects.rules.camel-case') }}
              <span class="bold txt-bold">{{ $t('pages.projects.rules.camel-case-eg') }}</span>
            </p>
          </div>
          <div class="edge edge-amount">
            <h3 :content="$t('pages.projects.modal.section-key')"></h3>
            <div class="row row-edit">
              <div class="col">
                <ValidatedField
                  type="text" id="key" name="key" class="mb-0" no-icon no-tooltip
                  v-model="project.key"
                  :disabled="updatePending"
                  ref="fieldAmount"
                  :rules="rulesFor('key')"
                />
              </div>
            </div>
          </div>
          <div class="edge edge-amount">
            <h3 :content="$t('pages.projects.modal.section-name')"></h3>
            <div class="row row-edit">
              <div class="col">
                <ValidatedField
                  type="text" id="name" name="name" class="mb-0" no-icon no-tooltip
                  v-model="project.name"
                  :disabled="updatePending"
                  ref="fieldAmount"
                  :rules="rulesFor('name')"
                />
              </div>
            </div>
          </div>
          <div class="edge edge-amount">
            <h3 :content="$t('pages.projects.modal.section-description')"></h3>
            <div class="row row-edit">
              <div class="col">
                <ValidatedField
                  type="text" id="description" name="description" class="mb-0" no-icon no-tooltip
                  v-model="project.description"
                  :disabled="updatePending"
                  ref="fieldAmount"
                  :rules="rulesFor('description')"
                />
              </div>
            </div>
          </div>
        </ValidationObserver>
      </b-modal>

      <div class="panel position-relative panel-content">
        <Breadcrumb :items=breadCrumbs() v-if="loaded"/>
        <div class="list d-none d-md-block left-edge">
          <p class="head-line justify-content-between">
            <span>{{ $t('pages.projects.title') }}</span>
            <search-filter
              v-model="filter" :disabled="!loaded || pending"
              :placeholder="$t('pages.projects.filter-tip')"
            />
            <spinner v-if="!loaded"/>
          </p>
          <div class="position-relative-w-100">
            <p class="txt-red">
              {{ $t('pages.projects.rules.camel-case') }}
              <span class="bold txt-bold">{{ $t('pages.projects.rules.camel-case-eg') }}</span>
            </p>
          </div>
          <div class="plans-table" v-if="loaded">
            <table class="w-100">
              <thead>
                <tr>
                  <th class="w-id">{{ $t('id') }}</th>
                  <th class="w-id">{{ $t('pages.projects.headers.key') }}</th>
                  <th class="w-name">{{ $t('pages.projects.headers.name') }}</th>
                  <th class="w-occupancy text-center">{{ $t('pages.projects.headers.description') }}</th>
                  <th class="w-actions">{{ $t('actions') }}</th>
                </tr>
              </thead>

              <tbody v-if="filteredProjects.length === 0 && loaded">
                <tr>
                  <td colspan="5" class="w-empty">{{ $t('pages.projects.no-projects') }}</td>
                </tr>
              </tbody>
              <tbody v-for="row in filteredProjects" :key="row.id">
                <tr class="separator before"></tr>
                <tr>
                  <td>
                    {{ row.id }}
                  </td>
                  <td>
                    {{ row.key }}
                  </td>
                  <td>
                    <p>{{ row.name }}</p>
                  </td>
                  <td class="text-center">
                    {{ row.description }}
                  </td>
                  <td class="actions">
                    <b-btn class="btn-icon btn-tiny"
                           @click="editProject(row)"
                           :disabled="updatePending" v-if="isAdmin"
                    >
                      <icon width="17" height="17" type="edit"
                            v-b-tooltip:page-channels.bottom="$t('pages.projects.tooltips.update-project')"
                      />
                    </b-btn>
                    <b-btn class="btn-icon btn-tiny" v-on:click="removeProject(row.id)" v-if="isAdmin">
                      <icon width="19" height="19" type="delete"
                            v-b-tooltip:page-channels.bottom="$t('pages.projects.tooltips.remove-project')"
                      />
                    </b-btn>
                    <b-btn class="btn-icon btn-tiny" @click="projectPageUrl(row.id)" v-if="!isImageEditor">
                      <icon width="19" height="19" type="connect"
                            v-b-tooltip:page-channels.bottom="$t('pages.projects.tooltips.project-page')"
                      />
                    </b-btn>
                    <b-btn class="btn-icon btn-tiny" @click="projectTranslationsUrl(row.id)" v-if="!isDeveloper">
                      <icon width="19" height="19" type="globe"
                            v-b-tooltip:page-channels.bottom="$t('pages.projects.tooltips.project-all-translations')"
                      />
                    </b-btn>
                  </td>
                </tr>
                <tr class="separator after"></tr>
              </tbody>
            </table>
          </div>
          <div v-if="loaded && isAdmin">
            <b-btn pill variant="outline-primary" class="add-new-plan"
                   @click="openCreateForm">
              <icon width="10" height="11" type="plus"/>
              {{ $t('pages.projects.button-add') }}
            </b-btn>
          </div>
        </div>
        <div class="d-md-none list-item" v-if="noProjects">
          <div class="w-empty">{{ $t('pages.roomtypes.no-rooms') }}</div>
        </div>
      </div>
      <div class="d-md-none add-new-plan-block" v-if="loaded && isAdmin">
        <b-btn pill variant="outline-primary" class="add-new-plan" @click="openCreateForm">
          <icon width="10" height="10" type="plus"/>
          {{ $t('pages.projects.button-add') }}
        </b-btn>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters, mapState } from 'vuex';

  export default {
    name: 'Projects',
    props: {
      payload: {
        validator: (v) => ['object', 'undefined'].includes(typeof v),
        default: null,
      },
    },
    data: () => ({
      project: {},
      filter: '',
    }),
    async created() {
      this.resetProjectModal();
      await this.fetchData(true);
    },
    computed: {
      ...mapGetters('projects', ['loaded', 'noProjects', 'projects']),
      ...mapGetters('user', ['isAdmin', 'isDeveloper', 'isTranslator', 'isImageEditor']),
      ...mapState('projects', ['error', 'pending', 'updatePending']),
      formValid() {
        return true;
      },
      modalTitle() {
        if (this.project.id == null) {
          return this.$t('pages.projects.modal.title-add');
        }
        const { id, name } = this.project;
        return this.$t('pages.projects.modal.title-edit', { id, name });
      },
      filteredProjects() {
        const filter = this.filter.trim().toLowerCase();
        let ret = this.projects;
        if (filter) {
          ret = ret.filter(({ id, name }) => (`${id}`.includes(filter) || name.toLowerCase().includes(filter)));
        }
        return ret;
      },
    },
    methods: {
      ...mapActions('projects', ['fetchData', 'createProject', 'updateProject', 'deleteProject']),

      modalScroll(ev) {
        const modal = ev.target;
        this.$nextTick(() => {
          if (modal != null) modal.scrollTop = 0;
        });
      },
      resetProjectModal() {
        this.project = {
          name: '',
          description: '',
          key: '',
        };
        if (this.$refs.projectForm != null) {
          this.$refs.projectForm.reset();
        }
      },
      openCreateForm() {
        this.resetProjectModal();
        this.$nextTick(this.$refs.projectModal.show);
      },
      editProject(project) {
        this.project = {};
        this.resetProjectModal();
        this.project = {
          ...this.project,
          ...JSON.parse(JSON.stringify(project)), // deep clone without bindings
        };
        this.$nextTick(() => {
          this.$refs.projectForm.reset();
          this.$refs.projectModal.show();
        });
      },
      async processForm() {
        const project = { ...this.project };
        if (this.payload != null) {
          Object.keys(this.payload).forEach((k) => {
            project[k] = this.payload[k];
          });
        }
        try {
          if (project.id != null) {
            await this.updateProject(project);
          } else {
            await this.createProject(project);
          }
          this.$refs.projectModal.hide();
          this.$toastr.s({
            title: project.id ? this.$t('pages.projects.alert-edit') : this.$t('pages.projects.alert-saved'),
            msg: '',
            timeout: 3000,
            progressbar: false,
          });
          await this.fetchData(true);
        } catch (error) {
          this.$toastr.e(error.message, this.$t('error'));
        }
      },
      rulesFor(field) {
        const rules = {
          required: true,
        };
        switch (field) {
          case 'name':
            break;
          case 'description':
            break;
          default:
            break;
        }
        return rules;
      },
      projectPageUrl(projectId) {
        this.$router.push({
          name: 'projects-pages',
          params: { id: projectId },
        });
      },
      projectTranslationsUrl(projectId) {
        this.$router.push({
          name: 'projects-all-translations',
          params: { id: projectId },
        });
      },
      breadCrumbs() {
        return [
          {
            text: this.$t('pages.dashboard.title'),
            to: { name: 'dashboard' },
          },
          {
            text: this.$t('pages.projects.title'),
            active: true,
          },
        ];
      },
      async removeProject(projectId) {
        if (window.confirm(this.$t('pages.projects.delete-modal.confirmation-msg'))) {
          await this.deleteProject(projectId);
          await this.fetchData(true);
          this.$toastr.s({
            title: this.$t('pages.projects.alert-delete'),
            msg: '',
            timeout: 3000,
            progressbar: false,
          });
        }
      },
    },
  };
</script>

<style>
/*.modal footer button {*/
/*  width: 40% ;*/
/*}*/
/*.modal .modal-body {*/
/*  padding-left: 9%;*/
/*}*/
</style>
